import { render, staticRenderFns } from "./CallCountChart.vue?vue&type=template&id=64cadcd0&scoped=true&"
import script from "./CallCountChart.vue?vue&type=script&lang=js&"
export * from "./CallCountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cadcd0",
  null
  
)

export default component.exports